/**
 * Javascript for loading custom eases.
 * 
 * @since 1.0.0
 */
export { LD_Custom_Eases };

import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin( CustomEase );

class LD_Custom_Eases {
  constructor() {
    CustomEase.create( "standard", "0.4, 0.0, 0.2, 1" );
    CustomEase.create( "entering", "0.0, 0.0, 0.2, 1" );
    CustomEase.create( "exiting", "0.4, 0.0, 1, 1" );  
  }
}